<template>
  <v-card color="#FFFFFF" elevation=0 tile :class="classes" :height="height" class="multipleLine"><slot></slot></v-card>
</template>

<script>
export default {
  props: {
    min: {
      type: Boolean,
      default: false
    },
    height: {
      type: Number,
      default: 150
    }
  },
  data: () => ({}),
  computed: {
    // `large`に応じてクラスを動的に生成する
    classes () {
      const cls = this.min ? 'pa-0' : 'pa-2'
      return cls
    }
  }
}
</script>

<style scoped>
.multipleLine {
  overflow-y: scroll;
  white-space: pre-wrap;
  resize: vertical;
}
</style>
